/**
 * 取得のタイミングを画面の表示・イベント・操作で決める query に付ける。
 * 再試行と、フォーカス時・再接続時の自動の再取得をしない。
 * 取得のたびに新しい参照のデータを返し、取得結果を依存配列に持つ effect が毎回働くようにする。
 */
export const NO_AUTO_REFETCH_QUERY_OPTIONS = {
  retry: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  structuralSharing: false,
} as const;

const MAX_RETRY_COUNT = 3;

// 通信エラー(fetch の TypeError)とサーバーエラーだけを再試行する。
// 4xx は結果が変わらず、タイムアウトは同じ待ち時間を重ねるだけになるため再試行しない
const isTransientError = (error: unknown) =>
  error instanceof TypeError || (error instanceof Response && error.status >= 500);

const retryOnTransientError = (failureCount: number, error: unknown) =>
  failureCount < MAX_RETRY_COUNT && isTransientError(error);

/**
 * 患者情報の query に付ける。フォーカス時・再接続時の自動の再取得はせず、一時的な失敗だけ再試行する。
 */
export const CURRENT_PATIENT_QUERY_OPTIONS = {
  ...NO_AUTO_REFETCH_QUERY_OPTIONS,
  retry: retryOnTransientError,
};
